import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// eslint-disable-next-line
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_TASKS_NEW_RECORD } from '../actions';

import {
    createTaskNewRecordSuccess,
    createTaskNewRecordError,
} from './actions';

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createTaskNewRecordAsync = async (payload) => {

  try{
    const responseObject = null;
    //const responseObject = await centralApiAxios.post("settings", newRecord);

    return {
    newsItem: responseObject.data,
    setting_id: responseObject.data.setting_id,
    trashed : payload.newRecord.trashed,
    isNewsItemCreate: !(payload.newRecord.setting_id > 0),
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }

};

function* createTaskNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(createTaskNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(createTaskNewRecordSuccess(resultReturned));
        window.location.reload();
      } else {
        yield put(createTaskNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createTaskNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_TASKS_NEW_RECORD, createTaskNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchCreateRecords)
    ]);
}
